import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Construction, Bell, ArrowLeft } from "lucide-react";
import { groupLabelFor } from "../config/underConstruction.js";

/**
 * Ecrã de bloqueio total para módulos ainda em construção.
 * Substitui integralmente o conteúdo da página — o utilizador não consegue
 * aceder a qualquer dado ou acção enquanto o módulo não estiver pronto.
 */
export default function UnderConstructionBlock() {
  const { pathname } = useLocation();
  const group = groupLabelFor(pathname) || "Este módulo";

  return (
    <div className="min-h-full flex items-center justify-center p-6" data-testid="under-construction-block">
      <div className="max-w-xl w-full bg-white border border-amber-200 rounded-lg shadow-soft-card overflow-hidden">
        <div className="bg-amber-100 border-b border-amber-200 px-6 py-4 flex items-center gap-3">
          <Construction className="w-6 h-6 text-amber-800" aria-hidden="true" />
          <div>
            <div className="text-[10px] uppercase tracking-widest font-heading font-bold text-amber-800">
              Módulo bloqueado
            </div>
            <h1 className="font-display text-xl font-bold text-amber-900">
              Em construção
            </h1>
          </div>
        </div>
        <div className="px-6 py-6 space-y-4">
          <p className="text-sm text-slate-700 leading-relaxed">
            O módulo <strong className="font-heading font-bold text-ronil-navy">{group}</strong> está
            em desenvolvimento e não está disponível neste momento.
          </p>
          <p className="text-sm text-slate-600 leading-relaxed inline-flex items-start gap-2">
            <Bell className="w-4 h-4 mt-0.5 shrink-0 text-ronil-navy" />
            <span>Será notificado assim que estiver pronto para utilizar.</span>
          </p>
          <div className="pt-2 flex items-center gap-2">
            <Link
              to="/anuncios"
              data-testid="under-construction-home-link"
              className="inline-flex items-center gap-1.5 bg-ronil-navy hover:bg-ronil-navy-hover text-white px-4 py-2 rounded-md text-sm font-heading font-semibold"
            >
              <ArrowLeft className="w-4 h-4" />
              Voltar aos Anúncios
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
